var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return typeof _vm.project == "object" &&
    _vm.project.engagement_manager &&
    _vm.getSystemSetting("project__show_engagement_manager") &&
    _vm.getSystemSetting("project__engagement_manager_lock")
    ? _c("div", { staticClass: "project-engagement-manager-lock-wrapper" }, [
        _vm.project.engagement_manager_locked
          ? _c(
              "button",
              {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.hover",
                    modifiers: { hover: true }
                  }
                ],
                staticClass: "btn btn-icon",
                attrs: {
                  title:
                    "Unlock to automatically set the engagement manager when the department for the project changes."
                },
                on: {
                  click: function($event) {
                    return _vm.doToggleProjectEngagementManagerLock(
                      _vm.project.id
                    )
                  }
                }
              },
              [_c("i", { staticClass: "icomoon-lock-solid" })]
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.project.engagement_manager_locked
          ? _c(
              "button",
              {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.hover",
                    modifiers: { hover: true }
                  }
                ],
                staticClass: "btn btn-icon",
                attrs: {
                  title:
                    "Lock to prevent the engagement manager from changing when the department for the project is changed"
                },
                on: {
                  click: function($event) {
                    return _vm.doToggleProjectEngagementManagerLock(
                      _vm.project.id
                    )
                  }
                }
              },
              [_c("i", { staticClass: "icomoon-unlock" })]
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }